import React from 'react';
import DigitalTransformationImg from "../../../images/DigitalTransformation-Web.png";
import Modal from "../../Common/Modals/Modal";
import StyledImageFluid from "../Image.styled";
import {Color} from "../../Common/Colors";
import Button from "../../Common/Buttons/Button";

const DigitalTransformationModalButton = () => {

    const [isOpen, setIsOpen] = React.useState(false);

    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        setIsOpen(false);
    };

    return (
        <div>
            <Button type="button" className="btn btn-primary" onClick={showModal}>Read more...</Button>
            <Modal id="digitalTransformationModal"
                   title="Process Improvement &amp; Reengineering"
                   onClose={hideModal}
                   show={isOpen}>
                <StyledImageFluid src={DigitalTransformationImg} alt="Digital Transformation"
                                  backgroundColor={Color.lightskyblue} rounded/>
                <p><strong>Digital transformation</strong> experience migrating and modernizing legacy
                    systems, software, and data.</p>
                <ul>
                    <li>Migrated systems running on the mainframe (PL1, CICS, Adabas) and in a client server
                        environment(C++, MFC, COM, MSSQL, TCP\IP) to run in a multi-tiered architecture
                        (Tomcat, Java, Groovy, Spring, Hibernate, Oracle).
                    </li>
                    <li>Ported a suite of native systems and applications acquired via an aquisition to run
                        on a virtualized platform allowing for high availability and redundancy.
                    </li>
                    <li>Participated in the building of a DevOps culture to shorten development lifecycles,
                        reduce deployment failures, improve testing, facilitate bettter communication and
                        collaboration, and reduce costs and IT headcount.
                    </li>
                </ul>
            </Modal>
        </div>
    );
}

export default DigitalTransformationModalButton;